import { render, staticRenderFns } from "./AmetrasPdfPageContentTemplate.vue?vue&type=template&id=40b5f3af&"
import script from "./AmetrasPdfPageContentTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasPdfPageContentTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports